"use client";

import React, { useState } from "react";
import Image from "next/image";
import parser from "html-react-parser";
import extractVideoId from "../helpers/videoHelper";
import stringHelpers from "../helpers/stringHelpers";
import buttonHelper from "./../helpers/buttonHelper";
import "./css/VideoHero.css";
import { getImageURL } from "@/helpers/imageURLHelper";

const VideoHero = ({
  actionButton,
  alignTitle,
  alignTextContent,
  alignVideo,
  backgroundImage,
  // customHtml,
  firstFrameImage,
  firstFrameImageSize,
  hTitleLevel,
  hTitleSeparator,
  inModalWindow,
  isVideoSizeLarge,
  layout,
  menu,
  playIconImage,
  text,
  title,
  videoAbove = false,
  videoUrl,
  withinContainer,
}) => {
  const getImageUrlBySize = (firstFrameImage, sizeName) => {
    if (!firstFrameImage || !firstFrameImage.formats || !sizeName) {
      return null;
    }
    const format = firstFrameImage.formats[sizeName];
    return format ?? null;
  };

  let imageUrl;
  if (firstFrameImage && firstFrameImageSize) {
    imageUrl = getImageUrlBySize(firstFrameImage, firstFrameImageSize);
  }

  const [modal, setModal] = useState(false);
  const openModal = (e) => {
    e.preventDefault();
    setModal(!modal);
  };

  const actionButtons = buttonHelper.getButtons(
    [actionButton],
    undefined,
    menu
  );

  const player = (videoUrl, isVideoSizeLarge) =>
    videoUrl ? (
      videoUrl.includes("youtube") || videoUrl.includes("youtu.be") ? (
        <iframe
          frameborder="0"
          allowfullscreen=""
          src={`https://www.youtube.com/embed/${extractVideoId(videoUrl)}`}
          class="tps-video-frame"
        ></iframe>
      ) : (
        <iframe
          src={`https://player.vimeo.com/video/${extractVideoId(
            videoUrl
          )}?h=1234567890`}
          width={`${!!isVideoSizeLarge ? "100%" : "640"}`}
          height={`${!!isVideoSizeLarge ? "100%" : "360"}`}
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          loop={true}
          autoPlay={true}
          loading="lazy"
          allowFullScreen
          frameBorder={"0"}
          data-ready={true}
        />
      )
    ) : (
      ""
    );

  const hTitleAlign = alignTitle ?? "left";
  const titleLevel = hTitleLevel ?? "h2";
  const modalWindowLink = (
    <a
      href="#"
      data-video-title={""}
      data-video-url={videoUrl}
      className={`tps-video-modal-link tps-video-${firstFrameImageSize} tps-float-${firstFrameImageSize} tps-float-${alignVideo}`}
      onClick={openModal}
    >
      {playIconImage && (
        <span
          className="tps-icon tps-icon-play lazyloaded"
          aria-hidden="true"
          data-bg={` ${getImageURL(playIconImage?.formats?.thumbnail?.url || playIconImage?.url)} `}
          style={{
            backgroundImage: `url(${getImageURL(
              playIconImage?.formats?.thumbnail?.url || playIconImage.url
            )})`,
          }}
        ></span>
      )}

      {firstFrameImage && (
        <Image
          alt={firstFrameImage?.alternativeText || ""}
          className="ls-is-cached lazyloaded"
          src={getImageURL(imageUrl?.url || firstFrameImage.url)}
          width={imageUrl?.width || firstFrameImage.width}
          height={imageUrl?.height || firstFrameImage.height}
          sizes="50vw"
        />
      )}
    </a>
  );

  const videoHero = (
    <>
      {/* start about us (text on the left or right, video small , without popup ) */}
      {!inModalWindow &&
        !["video-section", "editable-text"].includes(layout) && (
          <>
            {!videoAbove &&
              title &&
              parser(
                stringHelpers.hTag(
                  title,
                  titleLevel,
                  hTitleSeparator,
                  hTitleAlign
                )
              )}
            <div
              className={`tps-video-frame-wrapper tps-video-${
                isVideoSizeLarge ? "large" : "default"
              } tps-float-${firstFrameImageSize} tps-float-${alignVideo}`}
            >
              {player(videoUrl, isVideoSizeLarge)}
            </div>
            {!!videoAbove &&
              title &&
              parser(
                stringHelpers.hTag(
                  title,
                  titleLevel,
                  hTitleSeparator,
                  hTitleAlign
                )
              )}

            {text && (
              <div
                className={`tps-editable-text cell margin-bottom-3 ${
                  alignTextContent ? "text-" + alignTextContent : ""
                }`}
              >
                {parser(text)}
                {actionButton && (
                  <div style={{ textAlign: actionButton.align }}>
                    {actionButtons}
                  </div>
                )}
              </div>
            )}
          </>
        )}
      {/* end about-us (text on the left or right, video small , without popup ) */}
      {inModalWindow &&
        !["video-section", "editable-text"].includes(layout) && (
          <>
            <div className={`text-center tps-video-modal-link-wrapper`}>
              {modalWindowLink}
            </div>
            {text && (
              <div className="tps-video-caption">
                {parser(text)}
                {actionButton && (
                  <div style={{ textAlign: actionButton.align }}>
                    {actionButtons}
                  </div>
                )}
              </div>
            )}
          </>
        )}

      {/* homepage */}
      {layout == "video-section" && (
        <div
          className={`tps-video-section video-aligned-${alignVideo} lazyloaded home`}
          data-bg={backgroundImage ? `${getImageURL(backgroundImage.url)}` : ""}
          style={{
            backgroundImage: backgroundImage
              ? `url(${getImageURL(backgroundImage.url)})`
              : "",
          }}
        >
          <div className="grid-container tps-video-section-inner">
            {parser(
              stringHelpers.hTag(
                title,
                titleLevel,
                hTitleSeparator,
                hTitleAlign
              )
            )}

            <div className="grid-x grid-padding-y grid-padding-x align-middle">
              <div className="tps-video-cta-wrapper cell tablet-6 tablet-order-1">
                {inModalWindow && modalWindowLink}
                {/* 
                <div className="iframe-wrapper">
                  {player(videoUrl, isVideoSizeLarge)}
                </div>
                */}
              </div>
              {text && (
                <div className="tps-video-section-text tps-editable-text-wrapper cell tablet-6 tablet-order-2">
                  {parser(text)}
                  {actionButton && (
                    <div style={{ textAlign: actionButton.align }}>
                      {actionButtons}
                    </div>
                  )}
                </div>
              )}
            </div>
            {/* {text && (
             <div className="tps-editable-text cell margin-bottom-3">
               {parser(text)}
               {parser(customHtml)}
               {actionButton && (
                 <div style={{ textAlign: actionButton.align }}>
                  {actionButtons}
                 </div>
                  )}
              </div>
                )}
            */}
          </div>
        </div>
      )}

      {!inModalWindow && layout == "editable-text" && (
        <div className="tps-editable-text cell margin-bottom-3">
          {title &&
            parser(
              stringHelpers.hTag(
                title,
                titleLevel,
                hTitleSeparator,
                hTitleAlign
              )
            )}

          {player(videoUrl, isVideoSizeLarge)}
          {text && parser(text)}
        </div>
      )}

      {modal && (
        <section className="modal-bg">
          <div className="modal-align reveal-overlay tps-video-modal-overlay">
            <div
              className={`modal-video-align reveal video-modal ${
                isVideoSizeLarge ? "large" : ""
              }`}
            >
              <button
                className="close-button"
                data-close=""
                type="button"
                style={{
                  fontFamily: "Lato",
                  fontWeight: "300 !important",
                }}
                onClick={openModal}
              >
                <span className="sr-only">Close video modal</span>×
              </button>
              <div className="tps-video-frame-wrapper">
                {player(videoUrl, isVideoSizeLarge)}
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );

  return withinContainer ? (
    <div className={"grid-container"}>{videoHero}</div>
  ) : (
    videoHero
  );
};

export default VideoHero;
